import React, { ErrorInfo, ReactNode } from 'react';
import { Notifier } from '@airbrake/browser';
import styled from 'styled-components';

const Wrapper = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1.5625rem;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.15);
`;
const SadEmoji = styled.span`
  font-size: 2rem;
`;
// const TimeStamp = styled.div`
//   font-size: 10px;
//   color: grey;
// `;

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production';s

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  private airbrake: Notifier | undefined;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
    if (
      process.env.REACT_APP_AIRBRAKE_PROJECT_ID &&
      process.env.REACT_APP_AIRBRAKE_PROJECT_KEY
    ) {
      this.airbrake = new Notifier({
        projectId: process.env.REACT_APP_AIRBRAKE_PROJECT_ID,
        projectKey: process.env.REACT_APP_AIRBRAKE_PROJECT_KEY,
      });
    }
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    const { children } = this.props;
    // Reset the error state when the children prop changes
    if (prevProps.children !== children) {
      this.setState({ hasError: false });
    }
  }

  async componentDidCatch(error: Error, info: ErrorInfo) {
    // Display fallback UI
    this.setState({ hasError: true });
    // Send error to Airbrake
    if (this.airbrake) {
      try {
        await this.airbrake.notify({
          error,
          params: { info },
        });
      } catch (err) {
        // Handle any potential errors here
      }
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <Wrapper>
          <SadEmoji>🤕</SadEmoji>
          <span>Omg, Something went Wrong</span>
          {/* <TimeStamp>{format(new Date(), 'DD MMM, HH:MM a')}</TimeStamp> */}
        </Wrapper>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
